export default {
  siteName: 'AllChinaBuy Spreadsheet',
  tagline: 'Produits, Vendeurs, QC & Guides d\'Achat',
  navSpreadsheet: 'Tableur',
  navCategories: 'Catégories',
  navProducts: 'Produits',
  navReviews: 'Avis',
  navShipping: 'Livraison',
  navCoupons: 'Coupons',
  navWarehouse: 'Entrepôt',
  navQC: 'QC',
  navGuides: 'Guides',
  navSafety: 'Sécurité',
  navBlog: 'Blog',
  navAbout: 'À propos',
  navContact: 'Contact',
  languageSelector: 'Langue',
  ctaExplore: 'Explorer le Tableur',
  ctaBuyNow: 'Acheter Maintenant',
  ctaMainWebsite: 'Visiter le Site Principal',
  ctaBrowseGuides: 'Parcourir les Guides',
  heroTitle: 'AllChinaBuy Spreadsheet',
  heroSubtitle: 'Trouvez des Produits, Vendeurs & Ressources d\'Achat Plus Rapidement',
  heroDescription: 'Découvrez des listes de produits, des ressources vendeur, des guides QC, des informations de livraison et des conseils d\'achat dans un hub organisé AllChinaBuy.',
  trustLine: 'Ressources mises à jour • Guides pratiques • Recherche produits • Informations d\'achat et de livraison',
  whatIsTitle: 'Qu\'est-ce que le AllChinaBuy Spreadsheet ?',
  whatIsDesc: 'Le AllChinaBuy Spreadsheet est un moyen pratique d\'organiser et d\'explorer les ressources produits, les informations vendeur, les guides d\'achat et la recherche connexe. Notre objectif est de faciliter la découverte de produits et la recherche d\'achat en rassemblant des ressources utiles dans un hub consultable.',
  exploreResources: 'Explorer les Ressources AllChinaBuy',
  popularCategories: 'Catégories Populaires AllChinaBuy Spreadsheet',
  latestGuides: 'Derniers Guides AllChinaBuy',
  shippingCost: 'Guides de Livraison & Coûts AllChinaBuy',
  shippingCostDesc: 'Apprenez les méthodes de livraison, les facteurs de coût, les délais de livraison et les conseils pratiques pour vos commandes AllChinaBuy.',
  reviewTitle: 'Guide d\'Avis & Légitimité AllChinaBuy',
  reviewDesc: 'Trouvez des informations neutres sur l\'expérience de la plateforme, les considérations de sécurité, la sécurité du compte et la conscience des paiements.',
  compareTitle: 'Comparez Avant d\'Acheter',
  compareDesc: 'Utilisez des tableaux de comparaison pour évaluer les vendeurs, produits, options de livraison, normes QC, prix, entrepôts, coupons et méthodes d\'achat.',
  safetyTitle: 'Restez en Sécurité Lors des Achats',
  safetyDesc: 'Apprenez les conseils de sécurité essentiels et les meilleures pratiques pour les achats en ligne. Visitez notre Centre de Sécurité pour des conseils détaillés.',
  finalCTATitle: 'Prêt à Explorer le AllChinaBuy Spreadsheet ?',
  finalCTADesc: 'Parcourez nos dernières ressources de tableur, guides, comparaisons et informations d\'achat.',
  footerRights: 'Tous droits réservés.',
  footerDisclaimer: 'Ce site est un hub de ressources indépendant. Toutes les informations sont uniquement pour la recherche.',
  footerLinks: 'Liens Rapides',
  footerResources: 'Ressources',
  footerLegal: 'Légal',
  footerSitemap: 'Plan du Site',
  footerPrivacy: 'Politique de Confidentialité',
  footerTerms: 'Conditions d\'Utilisation',
  readMore: 'Lire la Suite',
  updated: 'Mis à jour',
  resourceSpreadsheet: 'AllChinaBuy Spreadsheet',
  resourceReviews: 'Avis AllChinaBuy',
  resourceShipping: 'Coût de Livraison AllChinaBuy',
  resourceWarehouse: 'Entrepôt AllChinaBuy',
  resourceCoupons: 'Coupons AllChinaBuy',
  resourceDiscounts: 'Codes de Réduction AllChinaBuy',
  resourceLegit: 'Légitimité & Sécurité AllChinaBuy',
  resourceQC: 'Guides QC AllChinaBuy',
  categoryClothing: 'Vêtements',
  categoryShoes: 'Chaussures',
  categoryAccessories: 'Accessoires',
  categoryElectronics: 'Électronique',
  categoryBags: 'Sacs',
  categoryStreetwear: 'Streetwear',
  categoryHome: 'Maison & Lifestyle',
  categoryPopular: 'Trouvailles Populaires',
  categorySellers: 'Vendeurs de Confiance',
  categoryQC: 'Ressources QC',
  aboutTitle: 'À propos d\'AllChinaBuy Spreadsheet',
  aboutDesc: 'Nous sommes un hub de ressources indépendant dédié à aider les acheteurs à rechercher et organiser les informations produits AllChinaBuy.',
  contactTitle: 'Contactez-nous',
  contactDesc: 'Vous avez des questions ou des suggestions ? Nous serions ravis de vous entendre.',
  safetyCenter: 'Centre de Sécurité',
  safetyCenterDesc: 'Conseils de sécurité essentiels et meilleures pratiques pour les achats en ligne et la recherche.',
  allchinabuySpreadsheet: 'AllChinaBuy spreadsheet',
  allchinabuyReview: 'AllChinaBuy review',
  allchinabuyShipping: 'AllChinaBuy shipping cost',
  allchinabuyCoupon: 'AllChinaBuy coupon',
  allchinabuyDiscount: 'AllChinaBuy discount code',
  allchinabuyWarehouse: 'AllChinaBuy warehouse',
  allchinabuyLegit: 'AllChinaBuy legit',
  allchinabuyQC: 'AllChinaBuy QC',
  allchinabuySellers: 'AllChinaBuy sellers',
  allchinabuyProducts: 'AllChinaBuy products',
  allchinabuyGuide: 'AllChinaBuy buying guide',
  breadcrumbHome: 'Accueil',
  breadcrumbBlog: 'Blog',
  breadcrumbAbout: 'À propos',
  breadcrumbContact: 'Contact',
  breadcrumbSafety: 'Sécurité',
  metaHomeTitle: 'AllChinaBuy Spreadsheet – Produits, Vendeurs, QC & Guides d\'Achat',
  metaHomeDesc: 'Explorez le AllChinaBuy Spreadsheet avec des listes de produits, des ressources vendeur, des guides QC, des informations de livraison, des avis, des coupons et des conseils d\'achat pratiques.',
  metaAboutTitle: 'À propos d\'AllChinaBuy Spreadsheet – Hub de Ressources',
  metaAboutDesc: 'Découvrez le hub de ressources AllChinaBuy Spreadsheet. Plateforme de recherche indépendante pour la découverte de produits, les avis vendeur et les guides d\'achat.',
  metaContactTitle: 'Contactez AllChinaBuy Spreadsheet – Restez en Contact',
  metaContactDesc: 'Contactez l\'équipe AllChinaBuy Spreadsheet pour des questions, suggestions ou demandes de ressources.',
  metaSafetyTitle: 'Centre de Sécurité – Conseils d\'Achats AllChinaBuy Spreadsheet',
  metaSafetyDesc: 'Restez en sécurité en recherchant AllChinaBuy. Apprenez la sécurité du compte, la conscience des paiements, la prévention du phishing et les pratiques de navigation sécurisée.',
  metaArticleTitle: 'Guide AllChinaBuy Spreadsheet – Ressources & Conseils d\'Achat',
  metaArticleDesc: 'Guides détaillés et articles sur les ressources AllChinaBuy Spreadsheet, les conseils d\'achat, les coûts de livraison et la recherche vendeur.',
  relatedArticles: 'Articles Connexes',
  backToHome: 'Retour à l\'Accueil',
  feature: 'Fonctionnalité',
  option: 'Option',
  bestFor: 'Idéal Pour',
  shippingMethod: 'Méthode de Livraison',
  speed: 'Vitesse',
  cost: 'Coût',
  tracking: 'Suivi',
  seller: 'Vendeur',
  category: 'Catégorie',
  price: 'Prix',
  notes: 'Notes',
  warehouse: 'Entrepôt',
  function: 'Fonction',
  storage: 'Stockage',
  qc: 'QC',
  lastModified: '2026-08-25',
  author: 'Équipe Éditoriale',
  published: 'Publié',
  lastUpdated: 'Dernière Mise à Jour',
  tableOfContents: 'Table des Matières',
  quickAnswer: 'Réponse Rapide',
  detailedExplanation: 'Explication Détaillée',
  practicalGuide: 'Guide Pratique',
  prosAndCons: 'Avantages & Inconvénients',
  commonMistakes: 'Erreurs Courantes',
  safetyNotes: 'Notes de Sécurité',
  faq: 'FAQ',
  ctaFunnel: 'Continuez à explorer les ressources AllChinaBuy ou visitez notre site principal pour plus de produits.',
  visitMain: 'Visiter le Site Principal',
  spreadsheetGuide: 'Guide Complet AllChinaBuy Spreadsheet',
  couponDesc: 'Découvrez les derniers coupons AllChinaBuy, codes de réduction, offres promotionnelles et comment les appliquer pour économiser sur vos commandes.',
  warehouseDesc: 'Comprenez les opérations d\'entrepôt AllChinaBuy, les processus de stockage, les procédures QC et le fonctionnement de la gestion des stocks.',
  qcDesc: 'Apprenez à lire les photos QC, inspecter les produits, identifier les problèmes de qualité et prendre des décisions éclairées avant l\'expédition.',
  spreadsheetGuideDesc: 'Un guide complet pour comprendre et utiliser le AllChinaBuy Spreadsheet pour la recherche de produits et les décisions d\'achat.',
  featuredProducts: 'Produits en Vedette',
  featuredProductsDesc: 'Parcourez notre sélection de produits populaires du AllChinaBuy Spreadsheet. Cliquez sur un article pour acheter maintenant.',
  viewAllProducts: 'Voir Tous les Produits',
  buyNow: 'Acheter Maintenant',
  productCatalog: 'Catalogue de Produits',
  productCatalogDesc: 'Parcourez notre sélection de produits du AllChinaBuy Spreadsheet. Cliquez sur un article pour acheter directement.',
  allProducts: 'Tous les Produits',
  items: 'articles',
  noProducts: 'Aucun produit dans cette catégorie.',
  lookingForMore: 'À la Recherche de Plus de Produits?',
  visitFullStore: 'Visiter le Magasin Complet',
  heroTrustUpdated: 'Ressources mises à jour',
  heroTrustPractical: 'Guides pratiques',
  heroTrustResearch: 'Recherche produits',
  categoryBrowseDesc: 'Parcourez les catégories de produits et explorez le AllChinaBuy Spreadsheet',
  showLess: 'Afficher Moins',
  showAllCategories: 'Afficher Toutes les Catégories',
  resourceCardDesc: 'Explorez les ressources et guides pour',
  articlesDesc: 'Derniers articles sur le AllChinaBuy Spreadsheet, guides d\'achat et recherche produits',
  shippingDisclaimer: 'Vérifiez les informations actuelles avant l\'achat. Les délais et coûts de livraison peuvent varier.',
  latestResources: 'Dernières Ressources',
  email: 'Email',
  responseTime: 'Délai de Réponse',
  website: 'Site Web',
  sendMessage: 'Envoyer le Message',
  fillRequired: 'Veuillez remplir tous les champs obligatoires.',
  messageTooLong: 'Le message doit contenir 500 caractères maximum.',
  thankYouMessage: 'Merci pour votre message! Nous vous répondrons bientôt.',
  safeBrowsingChecklist: 'Checklist de Navigation Sûre',
  verifyHTTPS: 'Vérifier HTTPS',
  verifyHTTPSDesc: 'Vérifiez toujours l\'icône de cadenas et le préfixe HTTPS avant de saisir des informations personnelles.',
  strongPasswords: 'Utiliser des Mots de Passe Forts',
  strongPasswordsDesc: 'Créez des mots de passe uniques avec un mélange de lettres, chiffres et symboles. Utilisez un gestionnaire de mots de passe.',
  twoFactorAuth: 'Activer l\'Authentification à Deux Facteurs',
  twoFactorAuthDesc: 'Ajoutez une couche de sécurité supplémentaire à vos comptes lorsque la plateforme le prend en charge.',
  researchBeforeBuy: 'Rechercher Avant d\'Acheter',
  researchBeforeBuyDesc: 'Prenez le temps de lire les avis vendeur, comparer les prix et vérifier les détails produits avant d\'acheter.',
  keepRecords: 'Garder les Preuves',
  keepRecordsDesc: 'Conservez les confirmations de commande, numéros de suivi et communications avec les vendeurs.',
  reportSuspicious: 'Signaler les Activités Suspectes',
  reportSuspiciousDesc: 'Si vous rencontrez des vendeurs suspects, faux sites ou tentatives de phishing, signalez-les immédiatement.',
  safetyDisclaimer: 'Ces informations de sécurité sont fournies à des fins éducatives. Nous ne pouvons pas garantir la sécurité de toute plateforme, vendeur ou transaction. Faites toujours vos propres recherches.',
  pageNotFound: 'Page non trouvée',
  pageNotFoundDesc: 'La page que vous recherchez n\'existe pas ou a été déplacée.',
  productCardDesc: 'Explorez les ressources et guides pour',
};